export const radii = {
  '0': 0,
  '0.5': 1,
  '1': 2,
  '2': 4,
  '3': 6,
  '4': 8,
  '5': 10,
  '6': 12,
  '8': 16,
  '10': 20,
  rounded: 9999,
  max: 999999,
} as const;
